import { queryOptions, keepPreviousData } from '@tanstack/react-query';
import HttpClient from '../../Api/HttpClient';
import handle401 from '../handle-401';
import config from '../../config';

const tasksListQuery = ({ pageSize = 25, page = 1, sort, filters } = {}) =>
  queryOptions({
    placeholderData: keepPreviousData,
    queryKey: ['tasks', pageSize, page, sort, filters],
    queryFn: handle401(async () => {
      const { data } = await HttpClient.getTasksList({ pageSize, page, sort, filters });

      return {
        ...data,
        pageSize: data.page_size,
        totalLate: data.total_late,
        totalScheduled: data.total_scheduled,
        totalOngoing: data.total_ongoing,
        results: data.results.map((task) => ({
          id: task.id,
          title: task.title,
          startDate: task.start_date,
          completed: task.is_completed,
          completionDate: task.actual_completion_date,
          endDate: task.end_date,
          status: task.status,
          duration: task.duration,
          side: task.side,
          project: {
            id: task.board.id,
            name: task.board.name,
            value: task.board.value,
            priority: task.board.priority,
            buyerCompany: {
              id: task.board.buyerCompany.id,
              name: task.board.buyerCompany.name,
              crmId: task.board.buyerCompany.crm_id,
              avatarUrl: config.REACT_S3_URL + task.board.buyerCompany.company_image,
            },
          },
          flow: {
            id: task.flow.id,
            label: task.flow.label,
          },
          internalAssignee: task.internal_assignee.id && {
            id: task.internal_assignee.id,
            firstName: task.internal_assignee.first_name,
            lastName: task.internal_assignee.last_name,
            email: task.internal_assignee.email,
            avatarUrl: task.internal_assignee.avatar_url,
          },
          externalAssignee: task.external_assignee.id && {
            id: task.external_assignee.id,
            firstName: task.external_assignee.first_name,
            lastName: task.external_assignee.last_name,
            email: task.external_assignee.email,
            avatarUrl: task.external_assignee.avatar_url,
          },
          owner: {
            id: task.owner.id,
            firstName: task.owner.first_name,
            lastName: task.owner.last_name,
            email: task.owner.email,
            avatarUrl: task.owner.avatar_url,
          },
          stepCount: task.step_count,
          completedStepCount: task.completed_step_count,
          documentCount: task.document_count,
        })),
      };
    }),
  });

export default tasksListQuery;

export function tasksByWeeks() {
  return queryOptions({
    queryKey: ['tasksByWeeks'],
    queryFn: handle401(async () => {
      const { data } = await HttpClient.getTasksByWeeks();

      return data.items;
    }),
  });
}
